import { Doc } from '@dadohr/shared/domainTypes/document';
import { IUser } from '@dadohr/shared/domainTypes/user';
import { Button } from '@material-ui/core';
import { Merge } from 'lucide-react';
import { useState } from 'react';
import { useUnsafeTranslation } from '../../../../i18next';
import { useRoutes } from '../../../../routes';
import { SelectEmployeeModal } from './SelectEmployeeModal';

export const MergeEmployeeButton = ({
  orgId,
  profileUser
}: {
  orgId: string;
  profileUser: Doc<IUser>;
}) => {
  const { t } = useUnsafeTranslation();
  const { ROUTES, goTo } = useRoutes();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<Merge size={16} />}
        onClick={() => setOpen(true)}
      >
        {t('Merge employee')}
      </Button>
      <SelectEmployeeModal
        open={open}
        onClose={() => setOpen(false)}
        orgId={orgId}
        fromUser={profileUser}
        onContinue={(otherUserId) => {
          setOpen(false);
          goTo(ROUTES.users.merge.url(profileUser.id, otherUserId));
        }}
      />
    </>
  );
};
